/* eslint-disable @typescript-eslint/naming-convention */
import equal from 'fast-deep-equal';

import { ICommonFormRef } from 'KnmErknmPackage/MainModule/interfaces/ICommonFormRef';
import { IKnmErknmFormViolatedRequirementsMandatory } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormViolatedRequirementsNpa';

export const getHasModifiedDirtyFields = (
  currentDirtyFields: {
    [key: string]: boolean;
  },
  formRef?: ICommonFormRef,
) => {
  return Object.keys(currentDirtyFields).some(item => {
    const { initial, value, modified: isModified } = formRef?.current.getFieldState(item) || {};

    if (Array.isArray(value)) {
      if (!initial && value.length > 0) {
        return true;
      }

      if (!initial && (!value || value.length < 1)) {
        return false;
      }

      if (initial && Array.isArray(initial) && initial.length > 0 && item.includes('requirementsNpa')) {
        const cleanedValue = cleanNpaFields(value, item);

        return isModified && !equal(cleanedValue, initial);
      }

      return isModified;
    }

    return isModified && !equal(initial, value);
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const cleanNpaFields = (arr: any, field: string): any => {
  if (!Array.isArray(arr)) return arr;

  return arr.map(item => {
    if (!item || typeof item !== 'object') return item as Object;

    const isMandatory = field.includes('mandatory');
    const isNpa = field.includes('requirementsNpa') && !isMandatory;

    if (isNpa) {
      const cleanedMandatory = Array.isArray(item?.mandatory) ? item?.mandatory?.map(cleanMandatory) : [];

      const { hasInvalidExistNpa, hasInvalidStructureNpa, ...cleanedItem } = item;

      return { ...cleanedItem, mandatory: cleanedMandatory };
    }

    if (isMandatory) {
      return cleanMandatory(item);
    }

    return item;
  });
};

const cleanMandatory = (m: IKnmErknmFormViolatedRequirementsMandatory) => {
  const {
    hasInvalidControlObjectFilter,
    hasInvalidRiscIndicatorsFilter,
    hasInvalidKno,
    hasInvalidSupervision,
    ...rest
  } = m;

  return rest;
};
